// Utilities
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";

// Service
import { teamMemberService } from "../../../../../Api/Services/TeamMembers"; // Import the service for updating attendance status

// CONSTANTS
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import { ITeamMembersAttendanceForm } from "../../types";

/**
 * Async thunk to handle approval attendance team members.
 * Dispatches an API call to the attendance service.
 */
export const approveAttendanceCorrectionTeamMembersAsyncThunk =
  createServiceAsyncThunk<IBaseResponse, ITeamMembersAttendanceForm>(
    ACTION_NAMES.UPDATE_TEAM_MEMBERS_ATTENDANCE_CORRECTION,
    (attendanceUpdateData) =>
      teamMemberService.updateAttendanceStatus(attendanceUpdateData),
    ERROR_MESSAGES.TEAM_MEMBERS_ATTENDANCE_APPROVE_UPDATE_FAILURE
  );

/**
 * Slice to manage the state for approval team members attendance.
 * Includes actions to clear errors and handle async states.
 */
const teamMembersAttendanceApprovedSlice = createGenericSlice<
  IBaseResponse,
  ITeamMembersAttendanceForm
>(
  SLICE_NAMES.TEAM_MEMBERS_ATTENDANCE_APPROVE, // Slice Name
  approveAttendanceCorrectionTeamMembersAsyncThunk // Async Thunk
);

// Exporting the actions from the slice to reset states
export const {
  clearError: clearTeamMembersAttendanceApprovalError,
  clearSuccessMessage: clearTeamMembersAttendanceApprovalSuccessMessage,
} = teamMembersAttendanceApprovedSlice.actions;

// Exporting the reducer to be used in the store
export default teamMembersAttendanceApprovedSlice.reducer;
